module.exports = __webpack_public_path__ + "static/media/your.82ca47b5.png";